export const OMIT_RECEIPT_EMAIL = 'Fahrschein-Quittung unerwünscht'

export const ACTIVE_CONTACTS = true
export const ONLY_CUSTOMERS = true

export enum RevokeMode {
  EVENT = 'Fahrten annulieren',
  RIDE = 'Fahrt annulieren',
}

export const HANDICAPS = [
  'Rollstuhl',
  'Tixi-Rollstuhl',
  'Stöcke',
  'Rollator',
  'Sehbehinderung',
  // 'Tixi-Bon',
]

export enum HANDICAPS1 {
  JOURNEY_HANDLING_DURATION_WHEELCHAIR = 'Rollstuhl',
  JOURNEY_HANDLING_DURATION_TIXI_WHEELCHAIR = 'Tixi-Rollstuhl',
  JOURNEY_HANDLING_DURATION_STICKS = 'Stöcke',
  JOURNEY_HANDLING_DURATION_ROLLATOR = 'Rollator',
  JOURNEY_HANDLING_DURATION_SEEING_IMPAIRMENT = 'Sehbehinderung',
}

export const SLOWDOWN_HANDICAPS = [
  'Rollstuhl',
  'Tixi-Rollstuhl',
]

export interface RideDetailModel {
  id: number
  rideId: number
  latestRideId: number
  eventId: number
  periodEventId?: number
  driverId: number
  driver: string
  vehicleId: number
  vehicle: string
  isVehicleBlocked: boolean
  prevRideId?: number
  isEventValidated?: boolean
  isRideValidated: boolean
  flatCost?: number
  isForeignRide?: boolean
  doSendInvoice: boolean
  wasInvoiced: boolean
  isFreeOfCharge: number
  handicaps: string[]
  eventComments: string
  customer: string
  customerId: number
  customerPhone?: number
  customerPhoneInfo?: string
  departureAddressId?: number
  departureAddress: string
  departureStreet?: string
  departureZip?: string
  departureLocation?: string
  departureDescription?: string
  departureFullAddress?: string
  departureLat?: number
  departureLng?: number
  arrivalAddressId?: number
  arrivalAddress: string
  arrivalStreet?: string
  arrivalZip?: string
  arrivalLocation?: string
  arrivalDescription?: string
  arrivalFullAddress?: string
  arrivalLat?: number
  arrivalLng?: number
  additionalPassengers: number
  escorts: number
  prevRideWaitTime?: number
  departureAt?: string
  departureAtUnix?: number
  arrivalAt: string
  arrivalAtUnix?: number
  appointmentAt?: string
  appointmentAtUnix?: number
  distance: number
  duration: number
  periodId?: number
  periodDays: string[]
  periodStartAt: string
  periodFinishOn: string
  // periodExcludedDates: string[]
  // periodIncludedDates: string[]
  rideComments?: string
  rideInternalComment?: string
  createdById: number
  payingMethodId?: number
  operationUserId: number
  eventPrice: number
  isDistanceFixed: boolean
}

export interface RideRequestModel {
  rideId: number
  eventId: number
  isVehicleBlocked: boolean
  isEventValidated: boolean
  isRideValidated: boolean
  flatCost?: number
  isForeignRide: boolean
  doSendInvoice: boolean
  isFreeOfCharge: number
  additionalWaitTime?: number
  customerId: number
  handicaps: string[]
  departureAddressId: number
  arrivalAddressId: number
  vehicleId: number
  prevRideId?: number
  additionalPassengers?: number
  escorts?: number
  prevRideWaitTime?: number
  createdById: number
  appointmentAt?: string
  departureAt?: string
  arrivalAt?: string
  distance: number
  duration: number
  periodEventId?: number
  periodId?: number
  periodStartAt: string
  periodFinishOn: string
  periodDays: string[]
  // periodExcludedDates: string[]
  // periodIncludedDates: string[]
  rideComments?: string
  rideInternalComment?: string
  eventComments: string
  payingMethodId?: number
  operationUserId?: number
  isDistanceFixed: boolean
}

export interface OpenRideModel {
  rideId: number
  eventId: number
  openRideNo: string
  departureAt: string
  arrivalAt: string
  customerContactId: number
  customer: string
  driverUserId: number
  driver: string
  vehicleId: number
  vehicle: string
  departureLocation: string
  arrivalLocation: string
  route: string
}

export interface SplitRideModel {
  rideId: number
  eventId: number
  splitRideNo: string
  departureAt: string
  arrivalAt: string
  customerContactId: number
  customer: string
  driverUserId: number
  driver: string
  vehicleId: number
  vehicle: string
  departureLocation: string
  arrivalLocation: string
  route: string
}

export interface EventModel {
  id: number
  lastRideId: number
  contactId: number
  periodEventId: number
  isForeignRide: boolean
  doSendInvoice: boolean
  comments: string
  isInvoiced: boolean
  handicaps: string[]
  flatCost: number
  isFreeOfCharge: boolean
  addEventWaitTime: number
  moneyPending: number
  reviewedById: number
  reviewedAt: string
  isValidated: boolean
  createdById: number
}

export interface HandicapModel {
  key: number
  value: string
}

export interface EventRevoke {
  eventId?: number
  rideId?: number
  userId?: number
}

export interface CancelRequest {
  rideId: number
  userId: number
  comment?: string
}

export interface WorkDayDriver {
  userId: number
  contactId: number
  vehicleId: number
  driver: string
  vehicle?: string
  comment?: string
}

export interface VehicleRideStatistics {
  vehicle: string
  statisticsYear: number
  departureLocation: string
  // departureZip: string
  statisticsLevel: number
  vehicleId: number
  janRides: number
  janDist: number
  febRides: number
  febDist: number
  marRides: number
  marDist: number
  aprRides: number
  aprDist: number
  mayRides: number
  mayDist: number
  junRides: number
  junDist: number
  julRides: number
  julDist: number
  augRides: number
  augDist: number
  sepRides: number
  sepDist: number
  octRides: number
  octDist: number
  novRides: number
  novDist: number
  decRides: number
  decDist: number
  totalRides: number
  totalDist: number
}

export interface CustomerRideStatistics {
  rowType: string
  contact: string
  statisticsYear: number
  homeLocation: string
  homeZip: string
  janDist: number
  febDist: number
  marDist: number
  aprDist: number
  mayDist: number
  junDist: number
  julDist: number
  augDist: number
  sepDist: number
  octDist: number
  novDist: number
  decDist: number
  totalDist: number
}
